(function () {
    'use strict';

    angular
        .module('app')
        .directive('slider', slider);

    slider.$inject = ['$window'];

    function slider($window) {
        // Usage:
        //     <slider></slider>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, $attrs) {
            var sliderId = "#" + $attrs.sliderId;

            jQuery(document).ready(function ($) {

                $(sliderId).find(".next").on("click", function () {
                    var currentImg = $(sliderId).find(".active");
                    var next = currentImg.next();

                    if (next.length) {
                        currentImg.removeClass("active").hide();
                        next.addClass("active").show();
                    }
                });

                $(sliderId).find(".prev").on("click", function () {
                    var currentImg = $(sliderId).find(".active");
                    var prev = currentImg.prev();
                    if (prev.length) {
                        currentImg.removeClass("active").hide();
                        prev.addClass("active").show();
                    }
                });

                //count current slide and how many
                var totalSlidesHtml = $(sliderId).find('span.total-slides');
                var totalSlides = $(sliderId).find("#slider .inner li").length;
                totalSlidesHtml.html(totalSlides);

                var currentIndexHtml = $(sliderId).find('.current-slide');
                var currentIndex = $(sliderId).find('li.active').index() + 1;
                currentIndexHtml.html(currentIndex);

                $(sliderId).find('.changeSlide').bind("click", function () {
                    var currentIndexHtml = $(sliderId).find('.current-slide');
                    var currentIndex = $(sliderId).find('li.active').index() + 1;
                    currentIndexHtml.html(currentIndex);
                });

            });

        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Blocks/ImageSliderBlock/_slider.js
// module id = 25
// module chunks = 0